<template lang="pug">
  span {{ item | convertDate }}
</template>

<script>
import GetItem from '@/Core/mixins/getItem';
import { convertDate } from '@/Core/filters/dates';

export default {
  mixins: [GetItem],
  filters: {
    convertDate,
  },
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
  },
};
</script>
